module.exports = __webpack_public_path__ + "static/img/5btn1.6ecd25e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity-template/5btn1.png
// module id = b255
// module chunks = 215